export default "__VITE_ASSET__BJ5Pe$OT__"